import { getCategoryIcon } from '../Common/icon-type';
import { IoMdCalendar } from '@react-icons/all-files/io/IoMdCalendar';
import { MdUpdate } from '@react-icons/all-files/md/MdUpdate';
import { MdOpenInBrowser } from '@react-icons/all-files/md/MdOpenInBrowser';
import { FaTags } from '@react-icons/all-files/fa/FaTags';
import { FaUser } from '@react-icons/all-files/fa/FaUser';

import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { styled } from '@linaria/react';
import { getLocaleDateString } from '../../utils/helpers';

const Item = (props) => {
  // console.debug('props', props);
  // if (!props.post.frontmatter.cover) {
  //   console.debug('prefix', props.post.fields.prefix);
  //   console.debug('slug', props.post.fields.slug);
  //   console.debug('title', props.post.frontmatter.title);
  // }
  const { isFeatured, theme, className } = props;
  let title, author, slug, datePublished, dateModified, tags, category, cover, excerpt, feature;
  if (props.post.contentful_id) {
    // contentful posts
    title = props.post.title;
    author = props.post.author;
    slug = props.post.slug;
    datePublished = props.post.datePublished;
    dateModified = props.post.updatedAt;
    cover = props.post.imageCoverHero;
    tags = props.post.tags;
    category = props.post.category;
    excerpt = props.post.excerpt.excerpt;
  } else {
    // markdown posts
    title = props.post.frontmatter.title;
    author = props.post.frontmatter.author;
    slug = props.post.fields.slug;
    dateModified = props.post.frontmatter.dateModified;
    datePublished = props.post.fields.prefix;
    cover = props.post.frontmatter.cover;
    tags = props.post.frontmatter.tags;
    category = props.post.frontmatter.category;
    feature = props.post.frontmatter.feature; //only available from /content/features-highlights/
    excerpt = props.post.excerpt;
  }

  // useEffect(() => {
  //   console.log('useEffect item mount', props);
  //   return () => {
  //     console.log('useEffect item unmount:', props);
  //   };
  // }, []);

  //500 data-sal-easing="ease-in-cubic"
  // data-sal-duration="1000" data-sal-easing="ease-out-back">

  const itemImage = getImage(cover);

  return (
    <React.Fragment>
      {isFeatured ? (
        <FeatureItemList theme={theme} className={className}>
          {/* <div data-sal="zoom-out" data-sal-duration="700" data-sal-easing="ease"> */}
          <Link to={slug} key={slug} className="link">
            <div className="gatsby-image-outer-wrapper-feature-item">
              <GatsbyImage image={itemImage} alt={title} />
            </div>
            <ItemH1Styled theme={theme}>
              {title} {getCategoryIcon(feature, true)}
            </ItemH1Styled>
            <ItemMetaStyled theme={theme}>
              <span>
                {getCategoryIcon(feature, true, '', 22)} {feature}
              </span>

              {tags && tags.length > 0 && (
                <span>
                  <FaTags size={16} />
                  {tags.map((tag) => tag + ' ')}
                </span>
              )}
            </ItemMetaStyled>
            <ItemExcerptStyled theme={theme}>{excerpt}</ItemExcerptStyled>
            <br />
          </Link>
          {/* </div> */}
        </FeatureItemList>
      ) : (
        <ItemList theme={theme} className={className}>
          <div data-sal="slide-up" data-sal-duration="700" data-sal-easing="ease-in-out-cubic">
            <Link to={slug} key={slug} className="link">
              <div className="gatsby-image-outer-wrapper-item">
                <GatsbyImage image={itemImage} alt={title} />
              </div>
              <ItemH1Styled theme={theme}>
                {title} {getCategoryIcon(category, true)}
              </ItemH1Styled>
              <ItemMetaStyled theme={theme}>
                {dateModified && (
                  <span>
                    <MdUpdate size={22} /> {getLocaleDateString(dateModified)}
                  </span>
                )}
                {!dateModified && (
                  <span>
                    <MdOpenInBrowser size={22} /> {getLocaleDateString(datePublished)}
                  </span>
                )}
                {/* <span>
                  <FaUser size={16} /> {author}
                </span> */}
                {category && (
                  <span>
                    {getCategoryIcon(category, true, '', 22)} {category}
                  </span>
                )}
                {tags && tags.length > 0 && (
                  <span>
                    <FaTags size={16} />
                    {tags.map((tag) => tag + ' ')}
                  </span>
                )}
              </ItemMetaStyled>
              <ItemExcerptStyled theme={theme}>{excerpt}</ItemExcerptStyled>
              <br />
            </Link>
          </div>
        </ItemList>
      )}
    </React.Fragment>
  );
};

Item.propTypes = {
  isFeatured: PropTypes.bool.isRequired,
  post: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  className: PropTypes.string,
};

export default Item;

const ItemList = styled.li`
  border: 1px solid transparent;
  border-radius: ${(props) => props.theme.size.radius.default};
  margin: ${(props) => props.theme.space.default} 0 ${(props) => props.theme.space.default};
  padding: ${(props) => props.theme.space.inset.s};
  position: relative;
  transition: var(--blog-item-transition);
  background: transparent;

  .gatsby-image-outer-wrapper-item {
    border-radius: ${(props) => props.theme.size.radius.default};
    border: 1px solid ${(props) => props.theme.line.color};
    overflow: hidden;
  }
  .gatsby-image-outer-wrapper-item img {
    z-index: -1;
  }

  &::after {
    border-top: 1px solid ${(props) => props.theme.line.color};
    content: '';
    height: 0;
    position: absolute;
    bottom: calc(${(props) => props.theme.space.default} * -1);
    left: 50%;
    transform: translateX(-50%);
    transition: all ${(props) => props.theme.time.duration.default};
    width: 50%;
  }

  &:last-child {
    &::after {
      display: none;
    }
  }

  @media (min-width: 680px) and (max-width: 980px) {
    &:nth-child(-n + 2) {
      margin: ${(props) => props.theme.space.default} 0 ${(props) => props.theme.space.default};
    }
    margin: calc(${(props) => props.theme.space.default} * 2) 0 ${(props) => props.theme.space.default};
    padding: ${(props) => props.theme.space.default};

    &:first-child {
      &::before {
        top: calc(${(props) => props.theme.space.default} * -1.75);
      }
    }
  }

  @media (min-width: 680px) {
    &:hover {
      border: 1px solid var(--border-line-color);
      box-shadow: var(--blog-item-hover-box-shadow);
      &:after {
        bottom: calc(${(props) => props.theme.space.default} * -2.5);
      }
      .gatsby-image-wrapper {
        transform: scale(1.1);
      }
      h1 {
        color: ${(props) => props.theme.blog.h1.hoverColor};
      }
      .arrow {
        opacity: 1;
        stroke: ${(props) => props.theme.color.special.attention};
        transform: translateX(0);
      }
    }
    .gatsby-image-wrapper {
      transition: all ${(props) => props.theme.time.duration.default};
    }
    h1 .arrow {
      display: inline-block;
      fill: ${(props) => props.theme.color.special.attention};
      stroke: ${(props) => props.theme.color.special.attention};
      font-size: 1.3em;
      left: 7px;
      opacity: 0;
      transition: all 0.5s;
      transform: translateX(-50%);
    }
    &:last-child:not(:nth-child(even)) {
      &::after {
        display: none;
      }
    }
  }

  @media (min-width: 980px) {
    &:first-of-type.isFocusPosts {
      grid-column: span 2;
    }
    &:first-of-type.isFocusPosts.isFocusLastPost {
      grid-column: 1;
    }
    &:last-of-type.isFocusPosts.isFocusLastPost {
      grid-column: span 2;
    }
    &:nth-child(-n + 3) {
      margin: ${(props) => props.theme.space.default} 0 calc(${(props) => props.theme.space.default} * 2);
    }

    margin: calc(${(props) => props.theme.space.default} * 2) 0
      calc(${(props) => props.theme.space.default} * 2);
    padding: 0px;

    &::after {
      bottom: calc(${(props) => props.theme.space.default} * -1.5);
    }

    &:first-child {
      &::before {
        top: calc(${(props) => props.theme.space.default} * -2.75);
      }
    }

    &:nth-last-child(-n + 3) {
      &::after {
        display: none;
      }
    }

    .blogItemLink:first-child > &::before {
      top: calc(${(props) => props.theme.space.default} * -2.75);
    }
  }
`;

const ItemH1Styled = styled.h1`
  padding: ${(props) => props.theme.space.m} ${(props) => props.theme.space.s} 0;
  line-height: ${(props) => props.theme.blog.h1.lineHeight};
  font-size: ${(props) => props.theme.blog.h1.size};
  &::before {
    display: table;
    content: '';
    margin-bottom: -0.17em;
  }
  &::after {
    display: table;
    content: '';
    margin-top: -0.11em;
  }

  .arrow {
    display: none;
    position: relative;
    top: 7px;
  }

  @media (min-width: 680px) and (max-width: 980px) {
    font-size: calc(${(props) => props.theme.blog.h1.size} * 1.2);
    padding: calc(${(props) => props.theme.space.default} * 1.5) ${(props) => props.theme.space.default} 0;
    transition: all 0.5s;
  }

  @media (min-width: 980px) {
    padding: calc(${(props) => props.theme.space.default} * 1.2) ${(props) => props.theme.space.default} 0;
  }

  @media (min-width: 2560px) {
    font-size: calc(${(props) => props.theme.blog.h1.size} * 1.48);
  }
`;

const ItemMetaStyled = styled.p`
  display: flex;
  flex-flow: row wrap;
  font-size: 0.8em;
  padding: ${(props) => props.theme.space.m} ${(props) => props.theme.space.s};
  background: transparent;

  svg {
    fill: ${(props) => props.theme.icon.color};
    margin: ${(props) => props.theme.space.inline.xs};
  }
  span {
    align-items: center;
    display: flex;
    text-transform: uppercase;
    margin: ${(props) => props.theme.space.xs} ${(props) => props.theme.space.s}
      ${(props) => props.theme.space.xs} 0;
  }
  @media (min-width: 680px) and (max-width: 980px) {
    padding: calc(${(props) => props.theme.space.m} * 1.5) ${(props) => props.theme.space.m};
  }
  @media (min-width: 980px) {
    padding: calc(${(props) => props.theme.space.default} * 1.5)
      calc(${(props) => props.theme.space.default} * 1.5) calc(${(props) => props.theme.space.default} * 0.5);
  }
  @media (min-width: 2560px) {
    font-size: calc(${(props) => props.theme.blog.h1.size} * 1.11);
  }
`;

const ItemExcerptStyled = styled.p`
  font-size: ${(props) => props.theme.font.size.s};
  line-height: ${(props) => props.theme.font.lineHeight.xl};
  padding: 0 ${(props) => props.theme.space.s};
  letter-spacing: 0.05em;
  &::before {
    display: table;
    content: '';
    margin-bottom: -0.17em;
  }
  &::after {
    display: table;
    content: '';
    margin-top: -0.11em;
  }

  @media (min-width: 680px) and (max-width: 980px) {
    padding: 0 ${(props) => props.theme.space.default};
  }
  @media (min-width: 980px) {
    padding: 0 calc(${(props) => props.theme.space.default} * 1.5);
  }
  @media (min-width: 2560px) {
    font-size: calc(${(props) => props.theme.blog.h1.size} * 0.96);
  }
`;

const FeatureItemList = styled.li`
  border: 1px solid transparent;
  border-radius: ${(props) => props.theme.size.radius.default};
  margin: ${(props) => props.theme.space.default} 0 ${(props) => props.theme.space.default};
  padding: ${(props) => props.theme.space.inset.s};
  position: relative;
  transition: var(--blog-item-transition);
  background: transparent;

  .gatsby-image-outer-wrapper-feature-item {
    border-radius: ${(props) => props.theme.size.radius.default};
    border: 1px solid ${(props) => props.theme.line.color};
    overflow: hidden;
  }
  .gatsby-image-outer-wrapper-feature-item img {
    z-index: -1;
  }

  &::after {
    border-top: 1px solid ${(props) => props.theme.line.color};
    content: '';
    height: 0;
    position: absolute;
    bottom: calc(${(props) => props.theme.space.default} * -1);
    left: 50%;
    transform: translateX(-50%);
    transition: all ${(props) => props.theme.time.duration.default};
    width: 50%;
  }

  &:last-child {
    &::after {
      display: none;
    }
  }

  @media (min-width: 680px) and (max-width: 980px) {
    &:nth-child(-n + 2) {
      margin: ${(props) => props.theme.space.default} 0 ${(props) => props.theme.space.default};
    }
    margin: calc(${(props) => props.theme.space.default} * 2) 0 ${(props) => props.theme.space.default};
    padding: ${(props) => props.theme.space.default};

    &:first-child {
      &::before {
        top: calc(${(props) => props.theme.space.default} * -1.75);
      }
    }
  }

  @media (min-width: 680px) {
    &:hover {
      border: 1px solid var(--border-line-color);
      box-shadow: var(--blog-item-hover-box-shadow);
      &:after {
        bottom: calc(${(props) => props.theme.space.default} * -2.5);
      }
      .gatsby-image-wrapper {
        transform: scale(1.1);
      }
      h1 {
        color: ${(props) => props.theme.blog.h1.hoverColor};
      }
      .arrow {
        opacity: 1;
        stroke: ${(props) => props.theme.color.special.attention};
        transform: translateX(0);
      }
    }
    .gatsby-image-wrapper {
      transition: all ${(props) => props.theme.time.duration.default};
    }
    h1 .arrow {
      display: inline-block;
      fill: ${(props) => props.theme.color.special.attention};
      stroke: ${(props) => props.theme.color.special.attention};
      font-size: 1.3em;
      left: 7px;
      opacity: 0;
      transition: all 0.5s;
      transform: translateX(-50%);
    }
    &:last-child:not(:nth-child(even)) {
      &::after {
        display: none;
      }
    }
  }

  @media (min-width: 980px) {
    &:first-of-type.isFocusPosts {
      grid-column: span 2;
    }
    &:nth-child(-n + 3) {
      margin: ${(props) => props.theme.space.default} 0 calc(${(props) => props.theme.space.default} * 2);
    }

    margin: calc(${(props) => props.theme.space.default} * 2) 0
      calc(${(props) => props.theme.space.default} * 2);
    padding: 0px;

    &::after {
      bottom: calc(${(props) => props.theme.space.default} * -1.5);
    }

    &:first-child {
      &::before {
        top: calc(${(props) => props.theme.space.default} * -2.75);
      }
    }

    &::after {
      display: none;
    }

    .blogItemLink:first-child > &::before {
      top: calc(${(props) => props.theme.space.default} * -2.75);
    }
  }
`;
